module.exports = __webpack_public_path__ + "media/post-registration/learn-more@2x-4962913a.png";